import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Form, FormGroup, Input, Button } from 'reactstrap';
import { authenticate } from '../../redux';

import './LoginForm.css';

import logo  from '../../assets/images/Kronos.svg';

const LoginForm = ({ hide_logo, appear }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();
    const location = useLocation();

    const [email, setEmail]       = useState('');
    const [password, setPassword] = useState('');

    const { logInErrorMessage, isAuthenticating, logInError } = useSelector(state => state.auth);

    const submit = e => {
        e.preventDefault();
        dispatch(authenticate(email, password));
    }

    return (
        <Form onSubmit={ submit } className={`LoginForm ${appear ? 'appear' : ''}`}>
            {!hide_logo && (
                <img className="logo" src={logo} alt="logo" />
            )}
            {location.state?.resetPasswordSuccess && (
                <div className="alert alert-success" role="status">
                    {location.state?.resetSuccessMessage || t('login.reset_success')}
                </div>
            )}
            <FormGroup>
                <Input
                    required
                    type="email"
                    autoComplete="username email"
                    name="email"
                    id="email"
                    placeholder={t("login.email")}
                    value={ email }
                    onChange={ e => setEmail(e.target.value) }
                />
            </FormGroup>
            <FormGroup>
                <Input
                    required
                    type="password"
                    autoComplete="current-password"
                    name="password"
                    id="password"
                    placeholder={t("login.password")}
                    value={ password }
                    onChange={ e => setPassword(e.target.value) }
                />
            </FormGroup>

            <Button className="btn btn-lg btn-block btn-dark">
                {isAuthenticating ?
                    <span>
                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                    </span>
                    :
                    <span>{t('login.title')}</span>
                }
            </Button>

            <p className="mt-2 mb-0">
                <Link to="/login/forgot">{t('login.forgot_password_link')}</Link>
            </p>

            {logInError &&
                <div
                    className="alert alert-danger alert-inline mt-3 mb-0"
                    role="alert"
                >
                    <span className="alert-inline-body">{logInErrorMessage}</span>
                </div>
            }
        </Form>
    );
}

export default LoginForm;
